import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp({}: any) {
    const { useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();

    return (
        <div className={`${css.msgA} msgA GtmModuleData-section`} data-section-id={css.msgA} data-section-title={t('delta2.aniF_msg1')}>
            <div className="v-msg">
                <div className="v-msg-1">{t('delta2.aniF_msg1')}</div>
                <div className="v-msg-2" style={locale === 'jp' ? { fontSize: '0.12rem' } : {}}>
                    {t.rich('delta2.aniF_msg2', {
                        line1: (text: string) => (
                            <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                                {text}
                            </Link>
                        ),
                    })}
                </div>
            </div>
        </div>
    );
}
